import { fetchResource } from '@/services/fetchService.js'

const headers = [
  { text: 'content.thumbnail', name: 'thumbnail', sortable: false, filterable: false },
  { text: 'content.title', name: 'title' },
  { text: 'content.category', name: 'category' },
  { text: 'content.section', name: 'section' },
  { text: 'content.topic', name: 'topic' },
  { text: 'content.contentType', name: 'contentType' },
  { text: 'content.mediaType', name: 'mediaType' },
  { text: '', name: 'data-table-expand' }
]
class ContentService {
  constructor() {
    this.type = ''
  }

  fetchItems = async ({ collectionKey = null, filter = null }) => {
    const params = {
      collection: collectionKey,
      filter: filter
    }
    const items = await fetchResource('items', params)
    return items
  }

  fetchItem = async ({ id, slug }) => {
    const resource = 'item'
    const path = id ? `${resource}/${id}` : `${resource}/slug/${slug}`
    const item = await fetchResource(path)
    return item
  }

  getContentHeaders = () => {
    return JSON.parse(JSON.stringify(headers))
  }

  fetchBook = async ({ bookId, bookPath }) => {
    const path = bookId ? `book/${bookId}` : 'book'
    const params = bookPath ? { path: bookPath } : {}

    const book = await fetchResource(path, params)
    return book
  }

  async fetchModelConfig({ modelId, modelPath }) {
    const path = modelId ? `model/${modelId}` : 'model'
    const params = modelPath ? { path: modelPath } : {}

    const model = await fetchResource(path, params, { ignoreNotFound: true })
    return model
  }
}

export default ContentService
export const contentService = new ContentService()
